/**
 * EmptyState Component
 * Display when no data is available
 */

import { Inbox } from 'lucide-react';

interface EmptyStateProps {
    title?: string;
    description?: string;
    icon?: React.ReactNode;
    action?: React.ReactNode;
    className?: string;
}

export function EmptyState({
    title = 'No data found',
    description,
    icon,
    action,
    className = '',
}: EmptyStateProps) {
    return (
        <div className={`flex flex-col items-center justify-center py-12 px-4 ${className}`}>
            <div className="text-gray-300 mb-4">
                {icon || <Inbox size={64} />}
            </div>
            <h3 className="text-lg font-medium text-gray-700 mb-2">{title}</h3>
            {description && (
                <p className="text-sm text-gray-500 text-center max-w-md mb-4">
                    {description}
                </p>
            )}
            {action}
        </div>
    );
}

export default EmptyState;
